import {
  GlobalDesignActionType,
  GlobalDesignGroupAction,
  ComparisonMode,
} from '../types';
import { cornerGrouping } from './grouping';
import CornerLobbyItem from './CornerLobbyItem';
import { resolveEditorComponent } from '../resolveEditorComponent';
import { StylesDerivedNativeActions } from '@wix/editor-platform-host-integration-apis';
import { getBaseManifestProcessingStrategy } from '../common/grouping/getBaseManifestProcessingStrategy';
import { cornerGroupDisplayFilter } from './groupDisplayFilter';

const cornerAction: GlobalDesignGroupAction = {
  type: GlobalDesignActionType.Group,
  panel: resolveEditorComponent({ default: () => import('./CornerStyles') }),
  lobbyItem: CornerLobbyItem,
  getManifestProcessingStrategy: getBaseManifestProcessingStrategy(
    StylesDerivedNativeActions.cornerStyles,
  ),
  groupDisplayFilter: cornerGroupDisplayFilter,
  comparisonMode: ComparisonMode.DirectProps,
  grouping: cornerGrouping,
};

export default cornerAction;
